import { Link } from "react-router-dom"
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";

export const ViewIcon = ({ to = "#" }) => {
    return (
        <Link to={to}>
            <IconButton aria-label="update" className="">
                <VisibilityIcon sx={{ color: "#C86337", fontSize: 26 }} />
            </IconButton>
        </Link>
    );
};
